import { Component, OnInit } from '@angular/core';

import { AlertService } from '../_services/alert.service';

@Component({
    selector: 'alert',
    templateUrl: 'alert.component.html'
})

export class AlertComponent {
    message: any;
    fade: boolean = false;

    constructor(private alertService: AlertService) { }

    ngOnInit() {

        this.alertService.getMessage().subscribe(message => {
            this.fade = false;
            this.message = message;
            let scope = this;
            setTimeout(() => {
                scope.fade = true;
                setTimeout(() => {
                    //scope.message = null;
                }, 1000);
            }, 3000);
        });
    }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/_directives/alert.component.ts